import React from "react";

export function Input({ className = "", type = "text", ...props }) {
    return (
        <input
            type={type}
            className={`w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 
      focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
            {...props}
        />
    );
}